import { render, staticRenderFns } from "./DivorcePersonName.vue?vue&type=template&id=4b0f4527"
import script from "./DivorcePersonName.vue?vue&type=script&lang=js"
export * from "./DivorcePersonName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports